<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-none element-with-heading" id="praise-for-a-justifiable-madness">
<div class="heading heading-with-title heading-without-image" id="praise-for-a-justifiable-madness-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for A Justifiable Madness:</h1>
</div>
</div>
</div>
</div>
<div class="text" id="praise-for-a-justifiable-madness-text">
<p class="first first-in-chapter first-full-width"><span class="first-phrase"><span class="drop-cap"><span class="first-punctuation">"</span>I</span> was</span> in my element here it was like One Flew Over the Cuckoo’s Nest." <b>Susan Hampson - Books From Dusk Till <span class="last-word">Dawn</span></b></p>
<p class="subsq">"This is a fascinating and insightful thriller about psychiatric treatment and diagnosis." <b>Caroline Vincent - Bits About <span class="last-word">Books</span></b></p>
<p class="subsq">"This is a really well written and unique storyline. As an avid blogger I crave unique storylines and I applaud the author on such a brilliant debut novel." <b>Philomena Callan - Cheekypee Reads And <span class="last-word">Reviews</span></b></p>
<p class="subsq">"A fantastically gripping read that I struggled to put down!" <b>Kate Noble - The Quiet <span class="last-word">Knitter</span></b></p>
<p class="subsq">"This story will make you wander who is the madman and what goes on within the system...A dark little twister of a read..." <b>Livia Sbarbaro - Goodreads <span class="last-word">Revewier</span></b></p>
<p class="subsq">"This is a great book that will keep you gripped throughout" <b>Julie Lacey - Goodreads <span class="last-word">Reviewer</span></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praiseforajustifiablemadness.vue?47c01c2a